import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fab from '@material-ui/core/Fab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/pro-duotone-svg-icons';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: 'primary',
        '&:hover': {
            backgroundColor: 'primary',
        },
    },
    fabProgress: {
        color: 'primary',
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: 'primary',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

function UploadingFileSpinner() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>
                <Fab
                    aria-label="save"
                    color="secondary"
                    size="large"
                >
                    <FontAwesomeIcon
                        icon={faFileUpload}
                        size="2x"
                        color="#0A54A2"
                    />
                </Fab>
                <CircularProgress
                    size={68}
                    className={classes.fabProgress}
                />
            </div>
        </div>
    );
}

export default UploadingFileSpinner;
